<div class="container m-0">
  <div *ngFor="let dayKey of weeklyScheduleService.dayKeys" class="row" [ngClass]="{'mt-2': dayKey != 'mon'}">
    <span class="col p-0">{{'lang.globals.weekday.' + dayKey | translate}}</span>
    <ng-container *ngIf="weeklySchedule[dayKey] && weeklySchedule[dayKey].intervals else closed">
      <span class="col p-0 text-right">{{hourRangesToString(weeklySchedule[dayKey].intervals)}}</span>
    </ng-container>
    <ng-template #closed>
      <span class="col p-0 font-italic text-right noselect">{{'lang.weeklySchedule.closed' | translate}}</span>
    </ng-template>
  </div>
</div>
